"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("swiper/react");
var useRequests_1 = __importDefault(require("../../../../../hooks/useRequests"));
var gamesThumbsMap_1 = __importDefault(require("../../../../../utilities/gamesThumbsMap"));
var MaterialIcon_1 = __importDefault(require("../../utils/MaterialIcon"));
var GameSlide = function (_a) {
    var game = _a.game;
    var gameMap = gamesThumbsMap_1.default.get(game.code);
    var getGameImage = (0, useRequests_1.default)().getGameImage;
    return ((0, jsx_runtime_1.jsx)(react_1.SwiperSlide, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "swiper-container-over-effect" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: getGameImage(game.code), alt: "game" }), (0, jsx_runtime_1.jsxs)("section", __assign({ className: "swiper-container-over-buttons" }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: gameMap.displayName }), (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { iconName: "play_arrow" }), (0, jsx_runtime_1.jsx)("p", { children: "Demo" })] }))] })) }));
};
GameSlide.displayName = "SwiperSlide";
exports.default = GameSlide;
